<div class="container-nuestra-facultad">
     <div class="title-card" style="background-color: rgb(95, 99, 168);">
        <h3 class="quicksand-bold">CONOCÉ LA FACULTAD</h3>
    </div>

    <div class="carrousel-simple">
        <app-carrousel-facultades-simple [cards]="info?.gallery?.items"></app-carrousel-facultades-simple>
    </div>
 </div>